import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';

// The hosted-login front door (G2) is composed INSIDE App.tsx, under its
// <BrowserRouter> — not here. @frontegg/react's FronteggProvider mounts its
// own <BrowserRouter> whenever it is not already inside a router, so
// wrapping <App/> with it here created a second router and React Router
// threw ("you cannot render a <Router> inside another <Router>"), which the
// root error boundary rendered instead of the login box. Caught live on
// staging 2026-08-23; locked down by fronteggRouterComposition.test.tsx.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
